<div class="wrapper flex vcenter" (click)="onCheck()">
  <div class="outter-box" [class.toggled-on]="checked">
    <div class="inner-box" *ngIf="checked"></div>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
